import { getEditDeadline } from '#/lib/getEditDealine';
import { isAfter } from 'date-fns';

export const isAfterEditDeadline = (booking: { pickUpDate: Date }) => isAfter(getEditDeadline(booking), new Date());
